import { render } from "./BarChart.vue?vue&type=template&id=612817c6&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=612817c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612817c6"]])

export default __exports__